import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=0936de72&"
import script from "./ToDoList.vue?vue&type=script&lang=js&"
export * from "./ToDoList.vue?vue&type=script&lang=js&"
import style0 from "@/static/theme.scss?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports